import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-primary-light-blue" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "align-top px-6 py-3 text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
}, " Nimi ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "align-top px-6 py-3 text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
}, " UID ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "align-top px-6 py-3 text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
}, " Kiirgustegevusloa omaja ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "align-top px-6 py-3 text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
}, " Kontaktisik ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "align-top px-6 py-3 text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
}, " E-mail ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "align-top px-6 py-3 text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
}, " Telefon ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "align-top px-6 py-3 text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
}, " Töötajaid ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "align-top px-6 py-3 text-left text-xs font-medium text-blue-900 uppercase tracking-wider"
}, " Kabinetid ", -1)
const _hoisted_10 = {
  key: 0,
  scope: "col",
  class: "align-top px-6 py-3 bg-primary-light-blue"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("thead", _hoisted_1, [
    _createElementVNode("tr", null, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      (_ctx.isAdmin)
        ? (_openBlock(), _createElementBlock("th", _hoisted_10))
        : _createCommentVNode("", true)
    ])
  ]))
}